module.exports = __webpack_public_path__ + "img/stas-main_320.e5d3a123.jpg";